$ = require 'jquery'
PopOver = require 'views/lib/pop-over'
View = require 'view'
templates = require 'views/internal/templates'

module.exports = class CropPhotoView extends View
  viewTitleKey: 'crop photo'

  events: ->
    'click .js-done': 'done'
    'click .js-back': 'back'

  setImage: (url) ->
    @url = url

  render: ->
    @$el.html templates.fill('crop_photo')

    @$('.crop-image')
    .attr 'src', @url
    .css
      'max-width': 4096
      'max-height': 4096
    .crop
      width: 270
      height: 270
    .on 'mousewheel', (e) ->
      crop = $(this).data('crop')
      if e.originalEvent.wheelDelta < 0
        crop.zoomIn()
      else
        crop.zoomOut()
    .on 'crop', (e) =>
      @cropX = e.cropX
      @cropY = e.cropY
      @cropW = e.cropW
      @cropH = e.cropH
    @

  done: ->
    elImage = @$('.crop-image')[0]
    $canvas = $('<canvas>').attr({ width: 270, height: 270 })
    context = $canvas[0].getContext('2d')
    context.drawImage(elImage, @cropX, @cropY, @cropW, @cropH, 0, 0, 270, 270)

    @options.savePhoto($canvas[0].toDataURL('image/png'))
    PopOver.hide()

  back: ->
    PopOver.popView()



// WEBPACK FOOTER //
// ./app/scripts/views/camera/crop-photo-view.coffee